<template>
    <vs-popup class="add-new-incoterms" id="popup" title="CAMPAIGN OPEN REPORT" @close="open = false" :active.sync="open"
        :buttons-hidden="true">
        <vx-card no-shadow>
            <vs-table :data="data_list">

                <template slot="thead">
                    <vs-th width="33%">EMAIL ADDRESS</vs-th>
                    <vs-th width="33%">CONTACT STATUS</vs-th>
                    <vs-th width="34%">OPENS COUNT</vs-th>
                </template>

                <template slot-scope="{data}">
                    <vs-tr :key="indextr" v-for="(tr, indextr) in data">

                        <vs-td :data="data[indextr].email_address">
                            {{ data[indextr].email_address }}
                        </vs-td>

                        <vs-td :data="data[indextr].contact_status">
                            {{ data[indextr].contact_status }}
                        </vs-td>

                        <vs-td :data="data[indextr].opens_count">
                            {{ data[indextr].opens_count }}
                        </vs-td>

                        <template class="expand-user" slot="expand">
                            <div class="con-expand-users w-1/2">
                                <h5 class="mb-4">Open timestamps</h5>
                                <ol class="ml-8" style="list-style-type: decimal;">
                                    <li v-for="(open, index) in data[indextr].opens" :key="index">
                                        {{ __dateTimeFormatter(open.timestamp) }}
                                    </li>
                                </ol>
                            </div>
                        </template>

                    </vs-tr>
                </template>

            </vs-table>
        </vx-card>
    </vs-popup>
</template>
  
<script>
import { RepositoryFactory } from '@/repository/RepositoryFactory'

const CrmRepository = RepositoryFactory.get('crm');

import vSelect from 'vue-select'

import SuccessMessage from '@/mixins/SuccessMessage'
import ErrorMessages from '@/mixins/ErrorMessages'

function initialState() {
    return {
        open: false,
        id: '',
        data_list: [],
    }
}

export default {
    name: 'ViewCampaignOpenReportPopUp',
    data() {
        return initialState()
    },
    methods: {
        async openPopup(id) {
            try {
                await Object.assign(this.$data, initialState());
                this.open = true;
                this.id = id
                this.data_list = []
                await this.fetchBantData()
            } catch (error) {

            }
        },
        async fetchBantData() {
            try {
                const { data } = await CrmRepository.getCampaignOpenReport(this.id)
                this.data_list = data.members
            } catch (error) {
                this.convertAndNotifyError(error);
            }
        },
    },
    components: {
        'v-select': vSelect,
    },
    mixins: [SuccessMessage, ErrorMessages],
}
</script>
  
<style scoped>
.add-new-incoterms>>>.vs-popup {
    /* min-height: 30% !important; */
    min-width: 40% !important;
}
</style>
  